module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "relative w-full h-screen p-4 bg-bleu-moyen flex items-center justify-center"
  }, [_c('button', {
    staticClass: "absolute top-4 right-4",
    attrs: {
      "aria-label": "Fermer",
      "title": "Fermer"
    },
    on: {
      "click": function($event) {
        return _vm.$router.back()
      }
    }
  }, [_c('i', {
    staticClass: "inline-block h-8 w-8 mask mask-close bg-white"
  })]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-col items-center gap-8"
  }, [_c('a', {
    staticClass: "bg-secondary rounded-2xl flex flex-col items-center justify-center text-white w-48 h-48 sm:w-64 sm:h-64 focus:outline-none focus:ring-2 focus:ring-white/60",
    attrs: {
      "id": "scan_otag",
      "href": "fi360://scan?success=tryGoTo"
    }
  }, [_c('p', {
    staticClass: "text-lg sm:text-2xl mb-2 text-center"
  }, [_vm._v("Scan"), _c('br'), _vm._v("OTAG BOUTEILLE")]), _vm._v(" "), _c('i', {
    staticClass: "inline-block h-24 w-24 sm:h-28 sm:w-28 mask mask-otag-bouteille bg-white"
  })]), _vm._v(" "), _c('a', {
    staticClass: "bg-primary rounded-2xl flex flex-col items-center justify-center text-white w-48 h-48 sm:w-64 sm:h-64 focus:outline-none focus:ring-2 focus:ring-white/60",
    attrs: {
      "id": "scan_itag",
      "href": "fi360://scan?success=tryGoToInstall"
    }
  }, [_c('p', {
    staticClass: "text-lg sm:text-2xl mb-2 text-center"
  }, [_vm._v("Scan"), _c('br'), _vm._v("OTAG INSTALL")]), _vm._v(" "), _c('i', {
    staticClass: "inline-block h-24 w-24 sm:h-28 sm:w-28 mask mask-otag-install bg-white"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b38c220","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/Otag.vue
// module id = 1011
// module chunks = 0